import { Component, OnInit } from '@angular/core';
import {CoordinatorsService} from '../coordinators/services/coordinators.service'

@Component({
    selector: 'app-coordinators',
    templateUrl: './coordinators.component.html',
    styleUrls: ['./coordinators.component.scss'],
    standalone: false
})
export class CoordinatorsComponent implements OnInit {
  nodeChangeSend:any;
  nodeUpdateSend:any;
  panelShow:boolean=false;
  constructor(
    private _coordinatorsService:CoordinatorsService,
  ) { }

  ngOnInit(): void {
    
  } 
  nodeChangeEvent(event :any)
  {
    this.panelShow=true;
    this.nodeChangeSend=event;
  }
  nodeUpdateEvent(event:any)
  {
    this.nodeUpdateSend=event;
  }
  nodeUpdateHidePanel(event:any)
  {
    this.panelShow=false;
  }
 
}
